import { Suspense } from 'react';
import Footer from './Footer';
import Header from './Header';
import { Outlet, useLocation, useNavigation } from 'react-router-dom';
import ScrollToTop from '@/components/ScrollToTop';
import { LogoLoadingScreen } from '@/components/loading/LogoLoadingScreen';

const DefaultLayout = () => {
    const navigation = useNavigation();
    const location = useLocation();
    const isNavigating =
        navigation.state === 'loading' ||
        (navigation.location != null && navigation.location.pathname !== location.pathname);

    return (
        <div className="relative">
            {isNavigating ? <LogoLoadingScreen variant="fullscreen" /> : null}

            <ScrollToTop />

            <div className="flex flex-col min-h-screen overflow-x-hidden relative font-alex bg-background text-foreground transition-colors">
                <Header />
                <div className="m-auto flex w-full flex-1 flex-col">
                    <Suspense fallback={<LogoLoadingScreen variant="fullscreen" />}>
                        <Outlet />
                    </Suspense>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default DefaultLayout;
